import { render, staticRenderFns } from "./Grade6DocumentDetail.vue?vue&type=template&id=e6b12484&scoped=true&"
import script from "./Grade6DocumentDetail.vue?vue&type=script&lang=js&"
export * from "./Grade6DocumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./Grade6DocumentDetail.vue?vue&type=style&index=0&id=e6b12484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b12484",
  null
  
)

export default component.exports